import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetDescription,
  SheetTitle,
} from "../../../../shadcn/components/ui/sheet";
import FunnelIcon from "../../../../icons/FunnelIcon";
import { Button } from "../../../../shadcn/components/ui/button";
import BuildingsIcon from "../../../../icons/BuildingsIcon";
import BuildingApartmentIcon from "../../../../icons/BuildingApartmentIcon";
import FactoryIcon from "../../../../icons/FactoryIcon";
import GarageIcon from "../../../../icons/GarageIcon";
import { Checkbox } from "../../../../shadcn/components/ui/checkbox";
import { Input } from "../../../../shadcn/components/ui/input";

import { Drawer, DrawerContent } from "../../../../shadcn/components/ui/drawer";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogTrigger,
  DialogDescription,
} from "../../../../shadcn/components/ui//dialog";

import CalendarDotsIcon from "../../../../icons/CalendarDotsIcon";
import { Calendar } from "../../../../shadcn/components/ui/calendar";
import { Switch } from "../../../../shadcn/components/ui/switch";
import VerifiedHammer from "../../../../icons/VerifiedHammer";
import {
  Context,
  getPrivatePropertySearchResults,
  getSearchResults,
  payloadToUrl,
} from "services";
import { useRouter } from "next/router";

interface FilterSectionMobileProps {
  handleClearFilters: any;
}

export default function FilterSectionMobile({
  handleClearFilters,
}: FilterSectionMobileProps) {
  const filterMenu = [
    {
      key: "Property Type",
      value: "Property Type",
    },
    {
      key: "Property Sub Type",
      value: "Property Sub Type",
    },
    {
      key: "Budget",
      value: "Budget",
    },
    // {
    //   key: "Institutes",
    //   value: "Institutes",
    // },
    // {
    //   key: "Date",
    //   value: "Date",
    // },
    // {
    //   key: "Private sale",
    //   value: "Private sale",
    // },
    {
      key: "Verified Property",
      value: "Verified Property",
    },
  ];
  {
    process.env.NEXT_PUBLIC_PYP_ENABLE === "true" &&
      filterMenu.push({
        key: "Listing Type",
        value: "Listing Type",
      });
  }

  const [activeTab, setActiveTab] = useState(filterMenu[0].value);
  const [activeDiscardTab, setActiveDiscardTab] = useState(false);

  const [isDataModified, setIsDataModified] = useState<{
    [key: string]: boolean;
  }>({
    "Property Type": false,
    "Property Sub Type": false,
    Budget: false,
    Institutes: false,
    Date: false,
    Auctions: false,
    "Private sale": false,
    "Verified Property": false,
  });
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [isDataChanged, setIsDataChanged] = useState(false);

  const setIsDataModifiedToDefault = () => {
    const defaultValues = {
      "Property Type": false,
      "Property Sub Type": false,
      Budget: false,
      Institutes: false,
      Date: false,
      Auctions: false,
      "Private sale": false,
      "Verified Property": false,
    };
    setIsDataModified(defaultValues);
  };

  useEffect(() => {
    const anyModified = Object.values(isDataModified)?.some((value) => value);
    setIsDataChanged(anyModified);
  }, [isDataModified]);

  const handleFilterOnApply = () => {
    setIsSheetOpen(false);
    setActiveDiscardTab(false);
  };
  const handleClearFilterOnClick = () => {
    if (isDataChanged) {
      setActiveDiscardTab(true);
    } else {
      handleClearFilters();
      setActiveDiscardTab(false);
      setIsSheetOpen(false);
      setIsDataModifiedToDefault();
    }
  };

  const handlerOnDiscord = () => {
    handleClearFilters();
    setIsSheetOpen(false);
    setActiveDiscardTab(false);
    setIsDataModifiedToDefault();
  };

  return (
    <div className="w-full grid grid-cols-1 lg:hidden">
      <Sheet key={"left"} open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <SheetTrigger asChild>
          <div className="flex justify-center items-center cursor-pointer">
            <FunnelIcon />
            <div className="text-sm font-openSans capitalize text-brand-bgBlack pl-2">
              Filter
            </div>
          </div>
        </SheetTrigger>
        <SheetContent side={"left"}>
          <SheetTitle className="hidden"></SheetTitle>
          <SheetDescription className="hidden"></SheetDescription>
          <div className="p-4 bg-white w-full h-full z-999">
            <div className="text-xl font-openSans font-semibold leading-6 text-brand-bgBlack">
              Filters
            </div>
            <div className="grid grid-cols-1 w-full mt-4">
              <div className="grid grid-cols-[2fr_3fr] h-screen">
                <div className=" border-r-[1px] flex flex-1 flex-col justify-start items-start">
                  {filterMenu.map((item: any, index: any) => {
                    return (
                      <button
                        key={index}
                        className={`bg-white ${
                          activeTab === item.value
                            ? "text-brand-orange"
                            : "text-brand-bgBlack"
                        } px-0 py-3 text-sm font-openSans leading-5 font-normal hover:bg-white hover:text-brand-orange`}
                        onClick={() => setActiveTab(item.value)}
                      >
                        {item.value}
                      </button>
                    );
                  })}
                </div>
                <div className="">
                  {activeTab === "Property Type" && (
                    <PropertyTypeCard setIsDataModified={setIsDataModified} />
                  )}
                  {activeTab === "Property Sub Type" && (
                    <PropertySubTypeCard
                      setIsDataModified={setIsDataModified}
                    />
                  )}
                  {activeTab === "Budget" && (
                    <BudgetCard setIsDataModified={setIsDataModified} />
                  )}

                  {activeTab === "Listing Type" && (
                    <ListingTypeCard setIsDataModified={setIsDataModified} />
                  )}
                  {/* {activeTab === "Private sale" && (
                    <PrivateSaleCard setIsDataModified={setIsDataModified} />
                  )} */}
                  {activeTab === "Verified Property" && (
                    <VerifiedPropertyCard
                      setIsDataModified={setIsDataModified}
                    />
                  )}
                </div>
              </div>
              <div className="fixed bottom-0 left-0 w-full flex flex-1 justify-between px-4 pb-4 bg-white">
                <Button
                  className="bg-white text-brand-bgBlack border-[1px]"
                  onClick={handleClearFilterOnClick}
                >
                  Clear Filter
                </Button>
                <Button onClick={handleFilterOnApply}>Show Property</Button>
                <Drawer
                  open={activeDiscardTab}
                  onClose={() => setActiveDiscardTab(false)}
                >
                  <DrawerContent>
                    <DiscardYourChangesCard
                      onApply={handleFilterOnApply}
                      onDiscard={handlerOnDiscord}
                    />
                  </DrawerContent>
                </Drawer>
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
interface CardProps {
  setIsDataModified: any;
}

const PropertyTypeCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const [selectedAssetType, setSelectedAssetType] = useState(
    searchForm.value.asset_type || null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleAssetTypeSelect = (selected: any) => {
    setIsDataModified((prev: any) => ({
      ...prev,
      "Property Type": true,
    }));
    searchForm.setField("asset_type", selected);
    searchForm.setField("sub_asset_type", "");
    setSelectedAssetType(selected);
  };

  return (
    <div className="px-4 py-2 grid grid-cols-2 gap-x-5 gap-y-3">
      <div
        onClick={() =>
          handleAssetTypeSelect({ label: "residential", value: "residential" })
        }
        className={`px-2 py-[14px] cursor-pointer border-2 ${
          selectedAssetType?.value === "residential"
            ? "border-brand-bgBlack"
            : "bg-[#F8F8F8] border-transparent"
        }`}
      >
        <BuildingsIcon />
        <div className="text-[10px] font-openSans text-brand-bgBlack mt-[14px]">
          Residential
        </div>
      </div>
      <div
        onClick={() =>
          handleAssetTypeSelect({ label: "commercial", value: "commercial" })
        }
        className={`px-2 py-[14px] cursor-pointer border-2 ${
          selectedAssetType?.value === "commercial"
            ? "border-brand-bgBlack"
            : "bg-[#F8F8F8] border-transparent"
        }`}
      >
        <BuildingApartmentIcon />
        <div className="text-[10px] font-openSans text-brand-bgBlack mt-[14px]">
          Commercial
        </div>
      </div>
      <div
        onClick={() =>
          handleAssetTypeSelect({ label: "industrial", value: "industrial" })
        }
        className={`px-2 py-[14px] cursor-pointer border-2 ${
          selectedAssetType?.value === "industrial"
            ? "border-brand-bgBlack"
            : "bg-[#F8F8F8] border-transparent"
        }`}
      >
        <FactoryIcon />
        <div className="text-[10px] font-openSans text-brand-bgBlack mt-[14px]">
          Industrial
        </div>
      </div>
      <div
        onClick={() =>
          handleAssetTypeSelect({ label: "others", value: "others" })
        }
        className={`px-2 py-[14px] cursor-pointer border-2 ${
          selectedAssetType?.value === "others"
            ? "border-brand-bgBlack"
            : "bg-[#F8F8F8] border-transparent"
        }`}
      >
        <GarageIcon />
        <div className="text-[10px] font-openSans text-brand-bgBlack mt-[14px]">
          Others
        </div>
      </div>
    </div>
  );
};

const PropertySubTypeCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const [checkedItems, setCheckedItems] = useState<
    { label: string; value: string }[]
  >([]);
  const [assetSubTypeOptions, setAssetSubTypeOptions] = useState<any[]>([]);

  const filterData = (dataToFilter: any) => {
    return (dataToFilter || []).map((data: any) => ({
      label: data.parent.sub_asset_type_name,
      value: data.parent.sub_asset_type_slug,
    }));
  };

  const getFilterForSubAssetType = (searchForm: any) => {
    const filters = [];
    if (searchForm.value.asset_type.value) {
      const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
      filters.push(currentFilterString);
    }
    return filters;
  };

  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getPrivatePropertySearchResults({
      searches: [
        {
          query_by: "",
          collection: "posted-properties",
          q: "*",
          facet_by:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          facet_return_parent:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: getFilterForSubAssetType(searchForm).join(" && "),
          max_facet_values: "500",
          infix: "always",
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    const initializeOptions = async () => {
      const data = await fetchOptions();
      setAssetSubTypeOptions(data[0]?.data || []);

      const initialCheckedItems = searchForm.value.asset_type
        ? Array.isArray(searchForm.value.sub_asset_type)
          ? searchForm.value.sub_asset_type
          : searchForm.value.sub_asset_type
          ? [searchForm.value.sub_asset_type]
          : []
        : [];

      setCheckedItems(initialCheckedItems);
    };

    initializeOptions();
  }, [searchForm.value.asset_type]);

  const handleCheckboxChange = (
    item: { label: string; value: string },
    isChecked: boolean
  ) => {
    setCheckedItems((prev) => {
      const updatedCheckedItems = isChecked
        ? [...prev, item]
        : prev.filter((checkedItem) => checkedItem.value !== item.value);

      searchForm.setField("sub_asset_type", updatedCheckedItems);
      setCheckedItems(updatedCheckedItems);
      setIsDataModified((prev: any) => ({
        ...prev,
        "Property Sub Type": true,
      }));
      return updatedCheckedItems;
    });
  };

  return (
    <div className="w-full max-h-screen overflow-scroll">
      {assetSubTypeOptions.map((item: any, index: number) => (
        <div key={index} className="flex items-center mt-2 px-4">
          <Checkbox
            checkIconClassName="text-brand-bgBlack"
            className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
            id={`asset-${index}`}
            checked={
              Array.isArray(checkedItems) &&
              checkedItems?.some(
                (checkedItem) => checkedItem.value === item.value
              )
            }
            onCheckedChange={(isChecked: boolean) =>
              handleCheckboxChange(item, isChecked)
            }
          />
          <label
            htmlFor={`bank-${index}`}
            className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey cursor-pointer"
          >
            {item.label}
          </label>
        </div>
      ))}
    </div>
  );
};

const BudgetCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const [minPrice, setMinPrice] = useState<number | "">("");
  const [maxPrice, setMaxPrice] = useState<number | "">("");
  const [error, setError] = useState<any>("");

  const handleMinPriceChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = e.target.value;
    const numericValue = value ? parseFloat(value) : "";
    setMinPrice(numericValue);
    setIsDataModified((prev: any) => ({
      ...prev,
      Budget: true,
    }));

    if (
      typeof maxPrice === "number" &&
      typeof numericValue === "number" &&
      numericValue >= maxPrice
    ) {
      setError("Minimum price must be less than maximum price.");
    } else {
      setError(null);
    }
  };

  const handleMaxPriceChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value = e.target.value;
    const numericValue = value ? parseFloat(value) : "";
    setMaxPrice(numericValue);
    setIsDataModified((prev: any) => ({
      ...prev,
      Budget: true,
    }));

    if (
      typeof minPrice === "number" &&
      typeof numericValue === "number" &&
      numericValue <= minPrice
    ) {
      setError("Max price must be greater than min price.");
    } else {
      setError(null);
    }
  };

  useEffect(() => {
    const updateReservePrice = () => {
      if (minPrice && minPrice && Number(minPrice) < Number(maxPrice)) {
        const formattedRange = `${Math.floor(
          Number(minPrice) / 100000
        )}-${Math.floor(Number(maxPrice) / 100000)}`;

        if (searchForm.value.reserve_price !== formattedRange) {
          searchForm.setField("reserve_price", formattedRange);
        }
      }
    };

    const handler = setTimeout(updateReservePrice, 1000);
    return () => clearTimeout(handler);
  }, [maxPrice, minPrice, searchForm]);

  return (
    <div className="p-2">
      <Input
        type="number"
        placeholder="Enter Minimum Price"
        value={minPrice}
        onChange={handleMinPriceChange}
      />
      <Input
        type="number"
        placeholder="Enter Maximum Price"
        className="mt-5"
        value={maxPrice}
        onChange={handleMaxPriceChange}
      />
      {error && (
        <div className="text-red-500 mt-2 text-xs font-openSans">{error}</div>
      )}
    </div>
  );
};
const InstitutesCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const [options, setOptions] = useState<any[]>([]);

  const filterData = (dataToFilter: any) =>
    (dataToFilter || []).map((data: any) => ({
      label: data.parent.bank_name,
      value: data.parent.bank_slug,
    }));

  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getPrivatePropertySearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          filter_by: `${
            searchForm.value.city.value
              ? `status:active && dump.location.city_name:${searchForm.value.city.label}`
              : "status:active"
          }`,
          filter: "true",
          facet_by: "dump.bank.bank_slug",
          facet_return_parent: "dump.bank.bank_slug",
          max_facet_values: "500",
          per_page: 0,
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    const initializeOptions = async () => {
      const data = await fetchOptions();
      setOptions(data[0]?.data || []);
    };
    initializeOptions();
  }, [searchForm.value.city]);

  const handleCheckboxChange = (
    bank: { label: string; value: string },
    isChecked: boolean
  ) => {
    const prev = searchForm.getField("institutes");
    if (Array.isArray(prev) && isChecked) {
      const selectedPrev = prev.filter(
        (item: any) => item?.value !== bank?.value
      );
      selectedPrev.push(bank);
      searchForm.setField("institutes", selectedPrev);
    } else if (Array.isArray(prev) && !isChecked) {
      const selectedPrev = prev.filter(
        (item: any) => item?.value !== bank?.value
      );
      if (selectedPrev.length > 0) {
        searchForm.setField("institutes", selectedPrev);
      } else {
        searchForm.setField("institutes", "");
      }
    } else if (isChecked) {
      searchForm.setField("institutes", [bank]);
    }
    setIsDataModified((prev: any) => ({
      ...prev,
      Institutes: true,
    }));
  };

  return (
    <div className="max-h-screen overflow-scroll px-2 pt-2 pb-14 flex gap-6 flex-col">
      {options.map((bank: any, index: number) => (
        <div key={index} className="flex items-center ">
          <Checkbox
            checkIconClassName="text-brand-bgBlack"
            className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
            id={`bank-${index}`}
            checked={
              Array.isArray(searchForm.getField("institutes")) &&
              searchForm
                .getField("institutes")
                ?.some((item: any) => item.value === bank.value) // Check if the current bank is selected
            }
            onCheckedChange={
              (isChecked: boolean) => handleCheckboxChange(bank, isChecked) // Pass the entire bank object
            }
          />
          <label
            htmlFor={`bank-${index}`}
            className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
          >
            {bank.label}
          </label>
        </div>
      ))}
    </div>
  );
};

const DateCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const [dateRangeValue, setDateRangeValue] = useState<string | null>(null);

  const formatDate = (date: Date | undefined): string => {
    if (!date) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  const handleDateSelect = (date: Date | undefined) => {
    setStartDate(date);
    setIsDataModified((prev: any) => ({
      ...prev,
      Date: true,
    }));
    setOpen(false);
  };

  const handleEndDateSelect = (date: Date | undefined) => {
    setEndDate(date);
    setIsDataModified((prev: any) => ({
      ...prev,
      Date: true,
    }));
    setEndDateOpen(false);
  };

  const dateToUnixTimestamp = (date: Date | undefined): number | null => {
    return date ? Math.floor(date.getTime()) : null;
  };

  const validateAndPrepareSearch = useCallback(() => {
    if (startDate && endDate && startDate > endDate) {
      return null;
    }
    const startTimestamp = dateToUnixTimestamp(startDate);
    const endTimestamp = dateToUnixTimestamp(endDate);
    if (startTimestamp && endTimestamp) {
      setDateRangeValue(`${startTimestamp}-${endTimestamp}`);
    } else {
      setDateRangeValue(null);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    validateAndPrepareSearch();
    if (dateRangeValue) {
      searchForm.setField("auction_start_date_unix_timestamp", dateRangeValue);
    }
  }, [
    dateRangeValue,
    startDate,
    endDate,
    searchForm,
    validateAndPrepareSearch,
  ]);

  return (
    <div className="flex flex-col gap-4 p-2">
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            variant="outline"
            className="flex gap-2 items-center w-full justify-between text-sm font-openSans text-brand-textLightGrey"
          >
            {startDate ? formatDate(startDate) : <span>Start date</span>}
            <CalendarDotsIcon width={16} height={16} />
          </Button>
        </DialogTrigger>
        <DialogContent removeIcon={true} className="max-w-[340px] rounded-lg">
          <DialogTitle className="hidden"> </DialogTitle>
          <DialogDescription className="hidden"></DialogDescription>
          <div className="font-openSans text-lg font-semibold text-brand-textLightGrey px-3">
            Select start date
          </div>
          <Calendar
            mode="single"
            selected={startDate}
            onSelect={handleDateSelect}
            initialFocus
          />
        </DialogContent>
      </Dialog>
      <Dialog open={endDateOpen} onOpenChange={setEndDateOpen}>
        <DialogTrigger asChild>
          <Button
            variant="outline"
            className="flex gap-2 items-center w-full justify-between text-sm font-openSans text-brand-textLightGrey"
          >
            {endDate ? formatDate(endDate) : <span>End date</span>}
            <CalendarDotsIcon width={16} height={16} />
          </Button>
        </DialogTrigger>
        <DialogContent removeIcon={true} className="max-w-[340px] rounded-lg">
          <DialogTitle className="hidden"> </DialogTitle>
          <DialogDescription className="hidden"></DialogDescription>
          <div className="font-openSans text-lg font-semibold text-brand-textLightGrey px-3">
            Select end date
          </div>
          <Calendar
            mode="single"
            selected={endDate}
            onSelect={handleEndDateSelect}
            initialFocus
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const AuctionsCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const scheduleData = [
    { label: "Auction", value: "dated" },
    { label: "Private", value: "undated" },
  ];

  const [selectedScheduleOption, setSelectedScheduleOption] = useState(
    scheduleData.find(
      (option) => option.value === searchForm.value.filter_by.value
    ) || null
  );

  const handleCheckboxChange = (value: any, isChecked: boolean) => {
    if (isChecked) {
      setSelectedScheduleOption(value);
      searchForm.setField("filter_by", value);
      setIsDataModified((prev: any) => ({
        ...prev,
        Auctions: true,
      }));
    } else {
      setSelectedScheduleOption(null);
      searchForm.setField("filter_by", "");
    }
  };

  return (
    <div className="max-h-screen overflow-scroll px-2 pt-2 flex gap-4 flex-col">
      {scheduleData.map(({ label, value }, index) => (
        <div key={index} className="flex items-center">
          <Checkbox
            checkIconClassName="text-brand-bgBlack"
            className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
            id={`schedule-${index}`}
            checked={selectedScheduleOption?.value === value || false}
            onCheckedChange={(isChecked: boolean) =>
              handleCheckboxChange({ label, value }, isChecked)
            }
          />
          <label
            htmlFor={`schedule-${index}`}
            className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
          >
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

const ListingTypeCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const scheduleData = [
    { label: "Auction", value: "dated" },
    { label: "Private", value: "undated" },
  ];

  const handleCheckboxChange = (value: any, isChecked: boolean) => {
    if (value?.value === "undated") {
      return;
    }

    window.location.href =
      searchForm.value.city.value === ""
        ? `/auction-properties`
        : `/auction-properties-in-${searchForm.value.city.value}`;
  };

  return (
    <div className="max-h-screen overflow-scroll px-2 pt-2 flex gap-4 flex-col">
      {scheduleData.map(({ label, value }, index) => (
        <div key={index} className="flex items-center">
          <Checkbox
            disabled={value === "undated" ? true : false}
            checkIconClassName="text-brand-bgBlack"
            className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
            id={`schedule-${index}`}
            checked={value === "undated" ? true : false}
            onCheckedChange={(isChecked: boolean) =>
              handleCheckboxChange({ label, value }, isChecked)
            }
          />
          <label
            htmlFor={`schedule-${index}`}
            className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
          >
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

const PrivateSaleCard = ({ setIsDataModified }: CardProps) => {
  const { searchForm }: any = useContext(Context);
  const privateSaleData = [
    // { label: "Private Treaty (By Banker)", value: "private_treaty" },
    { label: "Private Property (By Individual)", value: "private_property" },
  ];

  const [selectedScheduleOption, setSelectedScheduleOption] = useState(
    privateSaleData.find(
      (option) => option.value === searchForm.value.filter_by.value
    ) || null
  );

  const handleCheckboxChange = (value: any, isChecked: boolean) => {
    if (isChecked) {
      setIsDataModified((prev: any) => ({
        ...prev,
        "Private sale": true,
      }));
      setSelectedScheduleOption(value);
      searchForm.setField("filter_by", value);
    } else {
      setSelectedScheduleOption(null);
      searchForm.setField("filter_by", "");
    }
  };
  return (
    <div className="max-h-screen overflow-scroll px-2 pt-2 flex gap-6 flex-col">
      {privateSaleData.map(({ label, value }, index) => (
        <div key={index} className="flex items-center">
          <Checkbox
            checkIconClassName="text-brand-bgBlack"
            className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
            id={`schedule-${index}`}
            checked={selectedScheduleOption?.value === value || false}
            onCheckedChange={(isChecked: boolean) =>
              handleCheckboxChange({ label, value }, isChecked)
            }
          />
          <label
            htmlFor={`schedule-${index}`}
            className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
          >
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};
const VerifiedPropertyCard = ({ setIsDataModified }: CardProps) => {
  const verifiedPropertyData = [
    { label: "Verified Property", value: "auction_verified" },
  ];
  const { searchForm }: any = useContext(Context);
  const handleSwitchChange = (checked: boolean) => {
    const filterField = searchForm.getField("filter_by");
    if (checked) {
      if (filterField && filterField !== "") {
        searchForm.setField("ab_verified", {
          label: "Verified Property",
          value: "auction_verified",
        });
      } else {
        searchForm.setField("filter_by", {
          label: "Verified Property",
          value: "auction_verified",
        });
      }
    } else {
      const isFilterVerified =
        filterField &&
        verifiedPropertyData?.some((item) => filterField.value === item.value);

      if (isFilterVerified) {
        searchForm.setField("filter_by", "");
      } else {
        searchForm.setField("ab_verified", "");
      }
    }
    setIsDataModified((prev: any) => ({
      ...prev,
      "Verified Property": true,
    }));
  };
  return (
    <div className="flex items-center justify-between max-w-[400px] gap-2 px-3 py-2 bg-[#F8F8F8] rounded-lg drop-shadow-sm mx-2">
      <VerifiedHammer />
      <Switch
        checked={
          searchForm.getField("filter_by") !== ""
            ? verifiedPropertyData.find(
                (item) => searchForm.getField("filter_by").value === item.value
              )
              ? true
              : searchForm.getField("ab_verified") &&
                searchForm.getField("ab_verified") !== ""
              ? true
              : false
            : false
        }
        onCheckedChange={handleSwitchChange}
      />
    </div>
  );
};

interface DiscardYourChangesCardProps {
  onDiscard: () => void; // Handler for the Discard button
  onApply: () => void; // Handler for the Apply Filters button
}

const DiscardYourChangesCard = ({
  onDiscard,
  onApply,
}: DiscardYourChangesCardProps) => {
  return (
    <div className="px-4 w-full">
      <div className="mt-4">
        <h3 className="font-openSans text-lg font-semibold text-brand-bgBlack">
          Do you want to discard your changes?
        </h3>
        <p className="mt-5 text-sm font-openSans text-brand-textGrey">
          You made some filter modifications. With these modifications, how
          would you like to proceed?
        </p>
        <div className="w-full grid grid-cols-2 gap-6 mt-11 mb-4">
          <Button
            className="bg-white text-brand-bgBlack border-[1px]"
            onClick={onDiscard} // Call the external discard handler
          >
            Discard
          </Button>
          <Button onClick={onApply}>Apply Filters</Button>{" "}
          {/* Call the external apply handler */}
        </div>
      </div>
    </div>
  );
};
